import Axios from '@/utils/axios'

export default {
  enterOnQueue: (aso, idAsoMeetingRoom) => {
    return Axios.post('/meeting/enter-on-queue', { idAso: aso, idAsoMeetingRoom })
  },
  queueStatus: idAsoMeetingRoom => {
    return Axios.get(`/meeting/${idAsoMeetingRoom}/queue-status`)
  },
  leaveQueue: idAsoMeetingRoom => {
    return Axios.post('/meeting/leave-queue', { idAsoMeetingRoom })
  },
  enterOnRoom: (idAsoMeetingRoom, idMeetingRoom, tokenAtendimento) => {
    return Axios.post('/meeting/enter-on-room', { idAsoMeetingRoom, idMeetingRoom, tokenAtendimento })
  },
  checkAppointmentStatus: idAsoMeetingRoom => {
    return Axios.get(`/meeting/${idAsoMeetingRoom}/room-status`)
  },
  reviewMeeting: params => {
    return Axios.post('/meeting/review-meeting', params)
  },
  userHasNotJoined: params => {
    return Axios.post('/meeting/user-not-joined', params)
  }
}
